import { initializeApp } from 'firebase/app';
import {
  getMessaging,
  getToken,
  onMessage,
  isSupported
} from 'firebase/messaging';

// Firebase config
const firebaseConfig = {
  apiKey: 'AIzaSyAUEyv61olP5jiwflEi74LvmTKRsz5d6SQ',
  authDomain: 'concave-agri.firebaseapp.com',
  projectId: 'concave-agri',
  storageBucket: 'concave-agri.appspot.com',
  messagingSenderId: '69749560271',
  appId: '1:69749560271:web:977dd82560e4d08af0b8ba',
  measurementId: 'G-D395MPY777'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Declare messaging variable
let messaging = null;

// Only get messaging if environment supports it and HTTPS is used
if (
  typeof window !== 'undefined' &&
  (window.location.protocol === 'https:' ||
    window.location.hostname === 'localhost')
) {
  isSupported().then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    } else {
      console.warn('Firebase Messaging is not supported in this browser.');
    }
  });
}

// Request FCM token
export const requestForToken = async () => {
  try {
    if (!messaging) {
      console.warn('Messaging not initialized.');
      return null;
    }

    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_VAPID_KEY
    });

    if (currentToken) {
      return currentToken;
    } else {
      console.log('No registration token available.');
      return null;
    }
  } catch (err) {
    console.log('Error retrieving token:', err);
    return null;
  }
};

// FCM onMessage listener
export const onMessageListener = () =>
  new Promise((resolve) => {
    if (messaging) {
      onMessage(
        messaging,
        (payload) => {
          resolve(payload);
        },
        500
      );
    }
  });
